import React, { RefObject } from 'react';

import { ButtonTypes, SmallButton } from '@eika/button';
import { ExpandCard } from '@eika/expand-card';
import { IconTypes } from '@eika/icon';

import { FocusableHtmlElement } from '../hooks';
import { isCurrentSporsmalValid } from '../reducer/current-steg';
import { removeSporsmalListSporsmalsflytCollection } from '../reducer/sporsmalsflyt-actions';
import { useSporsmalsflytDispatch } from '../reducer/sporsmalsflytDispatchProvider';
import { getSporsmalVisibilityStatesFromCollection } from '../sporsmalsflyt-collection';
import { getSporsmalListVisibilityStates, SporsmalListSporsmalsflytCollection } from './sporsmalList-types';
import { getTitle } from './sporsmalListExpandCardTitle';
import { SporsmalListSporsmal } from './sporsmalListSporsmal';

const findFirstSporsmalWithError = (collection: SporsmalListSporsmalsflytCollection): string | undefined => {
    if (!collection.expanded) {
        return undefined;
    }
    const sporsmalVisibilityStates = getSporsmalVisibilityStatesFromCollection(collection.sporsmalsflytCollection);

    return sporsmalVisibilityStates
        .filter((visibilityState) => visibilityState.show)
        .find((visibilityState) => !isCurrentSporsmalValid(visibilityState.sporsmal))?.sporsmal?.sporsmal?.id;
};

interface Props {
    sporsmalflytCollection: SporsmalListSporsmalsflytCollection;
    showFeilmeldinger: boolean;
    onNext: () => void;
    removeButtonLabel: string;
    focusOnMount?: boolean;
    tittelFeltid?: string;
    subTittelFeltid?: string;
    showDeleteBtn?: boolean;
    toggle: (id: string) => void;
    errorRef?: RefObject<FocusableHtmlElement>;
}

export const SporsmalListExpandCard = ({
    sporsmalflytCollection,
    showFeilmeldinger,
    onNext,
    tittelFeltid,
    subTittelFeltid,
    toggle,
    removeButtonLabel,
    errorRef,
    focusOnMount = false,
    showDeleteBtn = false,
}: Props) => {
    const { currentSporsmalList } = sporsmalflytCollection.sporsmalsflytCollection;

    const dispatch = useSporsmalsflytDispatch();

    const remove = () => {
        dispatch(removeSporsmalListSporsmalsflytCollection(sporsmalflytCollection.id));
    };

    const firstSporsmalIdWithError = findFirstSporsmalWithError(sporsmalflytCollection);

    return (
        <ExpandCard
            title={!sporsmalflytCollection.expanded ? getTitle(currentSporsmalList, tittelFeltid) : undefined}
            subtitle={!sporsmalflytCollection.expanded ? getTitle(currentSporsmalList, subTittelFeltid) : undefined}
            id={sporsmalflytCollection.id}
            isExpanded={sporsmalflytCollection.expanded}
            setIsExpanded={() => toggle(sporsmalflytCollection.id)}
            icon={!sporsmalflytCollection.expanded ? IconTypes.PENN_24 : undefined}
            dataTrackId={sporsmalflytCollection.id}
        >
            {getSporsmalListVisibilityStates(sporsmalflytCollection.sporsmalsflytCollection).map(
                (sporsmalAndVisability, key) =>
                    sporsmalAndVisability.show && (
                        <SporsmalListSporsmal
                            key={`sporsmal-list-collection-list-${key + 1}`}
                            sporsmalflytCollectionId={sporsmalflytCollection.id}
                            sporsmal={sporsmalAndVisability.sporsmal}
                            showFeilmeldinger={showFeilmeldinger}
                            onNext={onNext}
                            focusOnMount={focusOnMount && key === 0}
                            errorRef={
                                sporsmalAndVisability.sporsmal.sporsmal.id === firstSporsmalIdWithError
                                    ? errorRef
                                    : undefined
                            }
                        />
                    ),
            )}
            <div className="sporsmal-list-expand-card-btns">
                {showDeleteBtn && (
                    <SmallButton
                        id={`fjern-btn-id-${sporsmalflytCollection.id}`}
                        buttonType={ButtonTypes.SMALL_NEGATIVE}
                        onClick={remove}
                    >
                        {removeButtonLabel}
                    </SmallButton>
                )}
                <SmallButton
                    id={`lagre-lukk-id-${sporsmalflytCollection.id}`}
                    onClick={() => toggle(sporsmalflytCollection.id)}
                >
                    Lagre og lukk
                </SmallButton>
            </div>
        </ExpandCard>
    );
};
